// Hook de cache para Notification Services usando Tanstack Query
// Mantiene la misma interfaz que los servicios originales
import { useQuery } from '@tanstack/react-query'
import NotificationsService from 'services/notifications'

/**
 * Hook de cache para notifications - NO CAMBIA LA LÓGICA EXISTENTE
 * Solo añade una capa de cache inteligente
 */
export const useNotificationQueries = (userId, email) => {
	// Cache para configuración de notificaciones
	const notificationsConfigQuery = useQuery({
		queryKey: ['notifications-config', userId, email],
		queryFn: () => NotificationsService.getNotificationsConfig({ email, userId }),
		staleTime: 5 * 60 * 1000, // 5 minutos - config cambia poco
		cacheTime: 15 * 60 * 1000, // 15 minutos en cache
		enabled: !!userId,
		retry: 2,
		retryDelay: 1000
	})

	// Cache para lista de notificaciones
	const notificationsQuery = useQuery({
		queryKey: ['notifications', userId, email],
		queryFn: () => NotificationsService.getNotifications({ email, userId }),
		staleTime: 90 * 1000, // 1.5 minutos - notificaciones pueden cambiar frecuentemente
		cacheTime: 5 * 60 * 1000, // 5 minutos en cache
		enabled: !!userId,
		retry: 2,
		retryDelay: 1000
	})

	// Función wrapper que mantiene la interfaz original para config
	const getCachedNotificationsConfig = () => {
		return new Promise((resolve, reject) => {
			if (notificationsConfigQuery.data) {
				// NotificationsService ya devuelve res.data, mantenemos estructura original
				resolve({ status: 200, data: notificationsConfigQuery.data })
			} else if (notificationsConfigQuery.error) {
				reject(notificationsConfigQuery.error)
			} else {
				notificationsConfigQuery.refetch().then(result => {
					if (result.data) {
						resolve({ status: 200, data: result.data })
					} else {
						reject(result.error || new Error('No notifications config available'))
					}
				})
			}
		})
	}

	// Función wrapper para lista de notificaciones
	const getCachedNotifications = () => {
		return new Promise((resolve, reject) => {
			if (notificationsQuery.data) {
				resolve({ status: 200, data: notificationsQuery.data })
			} else if (notificationsQuery.error) {
				reject(notificationsQuery.error)
			} else {
				notificationsQuery.refetch().then(result => {
					if (result.data) {
						resolve({ status: 200, data: result.data })
					} else {
						reject(result.error || new Error('No notifications available'))
					}
				})
			}
		})
	}

	return {
		// Datos de las queries
		notificationsConfig: notificationsConfigQuery.data,
		notifications: notificationsQuery.data,

		// Estados de loading
		notificationsConfigLoading: notificationsConfigQuery.isLoading,
		notificationsLoading: notificationsQuery.isLoading,

		// Errores
		notificationsConfigError: notificationsConfigQuery.error,
		notificationsError: notificationsQuery.error,

		// Funciones wrapper que mantienen la interfaz original
		getCachedNotificationsConfig,
		getCachedNotifications,

		// Funciones para invalidar cache cuando sea necesario
		invalidateNotificationsConfig: () => notificationsConfigQuery.refetch(),
		invalidateNotifications: () => notificationsQuery.refetch()
	}
}

export default useNotificationQueries
